import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/utils/button"
import {digg} from "diggerize"
import memo from "set-state-compare/build/memo"
import moment from "shared/moment"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import {Text} from "shared/base"
import useAnythingPro from "components/subscriptions/use-anything-pro"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsUserProTopBar extends ShapeComponent {
  static defaultProps = {
    onLayout: undefined
  }

  static propTypes = propTypesExact({
    onLayout: PropTypes.func,
    onUpgradePressed: PropTypes.func.isRequired
  })

  setup() {
    const anythingPro = useAnythingPro({
      userSubscriptions: {
        preload: ["last_period"],
        select: {
          Subscription: ["createdAt", "id"],
          SubscriptionPeriod: ["endsAt"]
        }
      }
    })
    const {t} = useI18n({namespace: "js.components.user.pro.top_bar"})
    const trialSubscription = digg(anythingPro, "trialSubscription")

    let daysUntilTrialExpire

    if (trialSubscription) {
      const lastSubscriptionPeriodEndsAt = moment(trialSubscription.lastPeriod().endsAt())

      daysUntilTrialExpire = lastSubscriptionPeriodEndsAt.diff(moment().startOf("day"), "days")
    }

    const userHasPro = React.useMemo(() => {
      if (anythingPro?.userProSubscriptions) {
        for (const userSubscription of anythingPro.userProSubscriptions) {
          if (userSubscription.plan().identifier() == "pro") {
            return true
          }
        }
      }

      return false
    }, [anythingPro.userProSubscriptions])

    this.setInstance({anythingPro, daysUntilTrialExpire, t, userHasPro})
  }

  render() {
    const {anythingPro, daysUntilTrialExpire, t, userHasPro} = this.tt
    const {schoolClassesWithPro, schoolsThroughClassWithSchoolPro, schoolsWithPro} = anythingPro
    const {onLayout, onUpgradePressed} = this.p
    let mode

    if (schoolClassesWithPro?.length > 0 || schoolsThroughClassWithSchoolPro?.length > 0 || schoolsWithPro?.length > 0 || userHasPro) {
      // Dont show the top bar
    } else if (anythingPro.hasProTrial) {
      mode = "showHasTrial"
    } else if (anythingPro.expiredProTrial) {
      mode = "showTrialExpired"
    }

    if (mode) {
      // eslint-disable-next-line no-underscore-dangle
      globalThis.__anythingPro = true
    }

    if (!mode) {
      return null
    }

    return (
      <View
        dataSet={this.cache("rootViewDataSet", {mode}, [mode])}
        onLayout={onLayout}
        style={this.rootViewStyle ||= {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          paddingTop: 10,
          paddingRight: 25,
          paddingBottom: 10,
          paddingLeft: 25,
          backgroundColor: "#2c2c96"
        }}
        testID="user/pro/top-bar"
      >
        <Text
          style={this.textStyle ||= {marginRight: 20, color: "#fff", fontSize: 16, fontWeight: "bold"}}
          testID="pro-top-bar-text"
        >
          {mode == "showTrialExpired" && t(".your_trial_has_expired")}
          {mode == "showHasTrial" && daysUntilTrialExpire == 0 && t(".your_trial_period_expires_today", {days: daysUntilTrialExpire})}
          {mode == "showHasTrial" && daysUntilTrialExpire > 0 && t(".your_trial_period_expires_in_x_days", {days: daysUntilTrialExpire})}
        </Text>
        <Button color="white" onPress={onUpgradePressed} size="small" title={t(".read_more")} />
        <Button
          color="purple"
          onPress={onUpgradePressed}
          size="small"
          style={this.upgradeButtonStyle ||= {marginLeft: 15}}
          testID="top-bar-upgrade-button"
          title={t(".upgrade")}
        />
      </View>
    )
  }
}))
